import { TextField, styled } from "@mui/material";

interface PillTextFieldProps {
  isSelected?: boolean;
}

const PillTextField = styled(TextField, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<PillTextFieldProps>(({ theme, isSelected }) =>
  theme.unstable_sx({
    flexShrink: 0,
    backgroundColor: "white",
    border: "2px solid",
    borderRadius: "100px",
    borderColor: isSelected ? "black" : "transparent",
    paddingLeft: 1,
    ".MuiInputBase-root": {
      height: "100%",
      ".MuiInputBase-input": {
        width: "auto",
        "&, &::placeholder": {
          ...theme.typography.button,
          opacity: 1,
        },
      },
    },
    ".MuiInputAdornment-positionStart": {
      ".MuiSvgIcon-root": {
        fontSize: "20px",
        color: "black",
      },
    },
    fieldset: {
      display: "none",
    },
    ".MuiInputBase-input": {
      fontWeight: isSelected ? "1000 !important" : "normal",
    },
  })
);

export default PillTextField;
